import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { userRoles } from "../utils/constant";
import { CmsUsersResponse } from "../utils/interfaces";
import useAccountHook from "./useAccountHook";
import useCmsAccountsQuery from "../queries/cmsAccount/useCmsAccountsQuery";

const useCouriersHook = () => {
  const { t } = useTranslation();
  const { query: data } = useAccountHook();
  const { query } = useCmsAccountsQuery(true, {
    pageNumber: 1,
    pageSize: 999999
  });
  const [couriers, setCouriers] = useState<CmsUsersResponse[][]>([[], []]);
  useEffect(() => {
    if (query.data) {
      const users = [...(query.data || [])] as CmsUsersResponse[];
      const allowedRoles = [userRoles.ROLE_ADMIN, userRoles.ROLE_USER, userRoles.ROLE_COURIER];
      setCouriers((c) => {
        const datas = users.filter((user) =>
          allowedRoles.some((role) => user.roles.includes(role))
        );
        return [c[0], datas];
      });
    }
  }, [query.data]);

  useEffect(() => {
    setCouriers((c) => {
      const res =
        data.data !== undefined ? [{ ...data.data, name: `${data.data.name} ${t("you")}` }] : c[0];
      return [res, c[1]];
    });
  }, [data.data, t]);

  return couriers.flat();
};

export default useCouriersHook;
